import { useEffect, useState } from 'react';
import { useAuthStore } from './store';
import { refreshSession } from './cognito';

export function useAuth() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const expiresAt = useAuthStore((s) => s.expiresAt);
  const [isReady, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const bootstrap = async () => {
      if (accessToken && expiresAt && expiresAt > Date.now() + 30_000) {
        if (!cancelled) setReady(true);
        return;
      }
      await refreshSession();
      if (!cancelled) setReady(true);
    };
    bootstrap();
    return () => {
      cancelled = true;
    };
  }, [accessToken, expiresAt]);

  const isAuthenticated =
    !!accessToken && !!expiresAt && expiresAt > Date.now();

  return { isAuthenticated, isReady };
}
